<template>
  <div>
    <vue-headful :title="`Create an Order - Halalize for Business`" />
    <v-container fluid>
      <v-layout>
        <v-flex xs7 md8>
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <h3 class="title font-weight-black mb-3">สร้างคำสั่งซื้อ</h3>
              <el-collapse v-model="activeNames">
                <el-collapse-item title="ประเภท" name="0">
                  <v-layout align-center wrap row>
                    <v-flex
                      xs6
                      md3
                      class="pa-2"
                      v-for="(item, index) in orderTypeList"
                      v-bind:key="index"
                    >
                      <div
                        v-bind:class="{ 'selected': item.selected }"
                        class="select-box text-xs-center"
                        @click="onOrderTypeChanged(item)"
                      >{{item.name}}</div>
                    </v-flex>
                  </v-layout>
                </el-collapse-item>
                <el-collapse-item
                  v-if="order.channel=='callcenter'"
                  title="รายละเอียดลูกค้า"
                  name="1"
                >
                  <el-row :gutter="0">
                    <el-col :span="24">
                      <div class="py-3">
                        <el-form
                          inline
                          ref="form"
                          label-position="left"
                          :model="user"
                          size="small"
                          @submit.native.prevent
                        >
                          <el-form-item label="Mobile Number">
                            <el-input v-model="form.mobile" size="mini"></el-input>
                          </el-form-item>
                          <el-form-item>
                            <el-button type="danger" size="mini" @click="findMobile">ค้นหา</el-button>
                            <el-button
                              type="danger"
                              size="mini"
                              v-if="!user.firstname"
                              @click="recipientDialog=true"
                            >เพิ่มใหม่</el-button>
                          </el-form-item>
                        </el-form>
                        <v-layout align-center wrap row>
                          <v-flex md6 class="pa-2" v-if="user.firstname">
                            <div class="select-box selected">
                              #{{user.id}} {{user.firstname}} {{user.lastname}}
                              <br />
                              ({{user.mobile}})
                            </div>
                          </v-flex>
                          <v-flex xs6 md3 class="pa-2" v-else>
                            <template v-if="order.user_ref_json!=null">
                              <div class="select-box selected">
                                {{order.user_ref_json.firstname}} {{order.user_ref_json.lastname}}
                                <br />
                                ({{order.user_ref_json.mobile}})
                              </div>
                            </template>
                          </v-flex>
                        </v-layout>
                      </div>
                    </el-col>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item
                  v-if="order.order_type!='coupon'"
                  title="รายละเอียดจัดส่ง"
                  name="2"
                >
                  <v-layout>
                    <v-flex xs12 md6>
                      <template v-if="order.order_type=='delivery'">
                        <strong>ไปยัง :</strong>
                        <div class="my-2 text-xs-left">
                          <el-button
                            size="mini"
                            type="danger"
                            @click="addressDialog=true"
                          >Select from map</el-button>
                        </div>
                        <div
                          class="select-box selected"
                          v-if="order.delivery_info.whereTo.address!=''"
                        >
                          {{order.delivery_info.whereTo.label}}
                          <br />
                          {{order.delivery_info.whereTo.address}}
                        </div>
                      </template>
                      <div class="mt-3">
                        <strong>เวลา :</strong>
                        <br />ส่งด่วน (+นาที)
                        <el-button type="text" @click="enableDate = !enableDate">เปลี่ยนเวลา</el-button>
                        <div v-if="enableDate">
                          <el-date-picker
                            v-model="date"
                            type="datetime"
                            :editable="false"
                            :clearable="false"
                            :format="`dd-MM-yyyy HH:mm`"
                            @change="onDateChanged"
                            placeholder="Select date and time"
                          ></el-date-picker>
                        </div>
                      </div>
                    </v-flex>
                    <v-flex xs0 md6></v-flex>
                  </v-layout>
                </el-collapse-item>
                <el-collapse-item title="สินค้า" name="3">
                  <div class="my-2 text-xs-right">
                    <el-button size="mini" type="danger" @click="basketDialog=true">
                      <template v-if="order.basket.length<=0">เพิ่ม</template>
                      <template v-else>แก้ไข</template>
                    </el-button>
                  </div>
                  <div class="ma-4">
                    <template v-if="order.basket.length>0">
                      <el-row :gutter="10" v-for="(item, index) in order.basket" v-bind:key="index">
                        <el-col :span="2" class="mb-3">
                          <span>{{item.quantity}} x</span>
                        </el-col>
                        <el-col :span="17" class="mb-3">
                          {{item.name}}
                          <div
                            class="grey--text"
                          >หน่วยละ : ฿{{item.regular_price | numFormat('0,0')}}</div>
                        </el-col>
                        <el-col
                          :span="5"
                          class="mb-3 text-xs-right"
                        >฿ {{item.regular_price*item.quantity | numFormat('0,0')}}</el-col>
                      </el-row>
                      <v-divider class="my-3"></v-divider>
                      <el-row :gutter="10" class="title">
                        <el-col :span="2" class="mb-3"></el-col>
                        <el-col :span="12" class="mb-3">Sub Total</el-col>
                        <el-col
                          :span="10"
                          class="mb-3 text-xs-right"
                        >฿ {{order.amount.sub_total | numFormat('0,0')}}</el-col>
                      </el-row>
                    </template>
                    <template v-else>
                      <div class="text-xs-center pa-5">Basket Empty</div>
                    </template>
                  </div>
                </el-collapse-item>
                <el-collapse-item title="การชำระเงิน" name="5">
                  <v-layout align-center wrap row>
                    <v-flex
                      xs6
                      md3
                      class="pa-2"
                      v-for="(item, index) in paymentList"
                      v-bind:key="index"
                    >
                      <div
                        v-bind:class="{ 'selected': item.selected }"
                        class="select-box text-xs-center"
                        @click="onPaymentChanged(item)"
                      >{{item.name}}</div>
                    </v-flex>
                  </v-layout>
                </el-collapse-item>
                <el-collapse-item title="หมายเหตุ" name="4">
                  <el-row :gutter="15">
                    <el-col :span="12">
                      <div class="py-3">
                        <el-form
                          ref="form"
                          label-position="top"
                          :model="user"
                          size="small"
                          label-width="80px"
                        >
                          <el-form-item label="Internal">
                            <el-input type="textarea" v-model="order.remark_internal" rows="4"></el-input>
                          </el-form-item>
                        </el-form>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="py-3">
                        <el-form
                          ref="form"
                          label-position="top"
                          :model="user"
                          size="small"
                          @submit.native.prevent
                        >
                          <el-form-item label="Public">
                            <el-input type="textarea" v-model="order.remark_public" rows="4"></el-input>
                          </el-form-item>
                        </el-form>
                      </div>
                    </el-col>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item title="ข้อมูลออกในกำกับภาษี" name="6">
                  <div>Not available yet.</div>
                </el-collapse-item>
              </el-collapse>
            </el-card>
          </div>
        </v-flex>
        <v-flex xs5 md4 class="pl-3">
          <div class="sticky">
            <el-card class="box-card">
              <h3 class="title font-weight-black mb-3">Summary</h3>
              <el-row :gutter="15" class="mt-2">
                <el-col :span="12">Sub Total</el-col>
                <el-col
                  :span="12"
                  class="text-xs-right"
                >฿ {{order.amount.sub_total | numFormat('0,0.00')}}</el-col>
              </el-row>
              <el-row :gutter="15" class="mt-2">
                <el-col :span="12">Delivery Fee</el-col>
                <el-col :span="12" class="text-xs-right">฿ {{order.amount.delivery_fee}}</el-col>
              </el-row>
              <el-row :gutter="15" v-if="order.amount.extra_fee>0" class="mt-2">
                <el-col :span="12">Extra Fee</el-col>
                <el-col :span="12" class="text-xs-right">฿ {{order.amount.extra_fee}}</el-col>
              </el-row>
              <el-row :gutter="15" v-if="order.amount.discount<0" class="mt-2">
                <el-col :span="12">Discount</el-col>
                <el-col :span="12" class="text-xs-right">฿ {{order.amount.discount}}</el-col>
              </el-row>
              <v-divider class="my-3"></v-divider>
              <el-row :gutter="15">
                <el-col :span="12">Order Type</el-col>
                <el-col :span="12" class="text-xs-right">{{order.order_type}}</el-col>
              </el-row>
              <el-row :gutter="15" class="mt-2">
                <el-col :span="12">Payment Type</el-col>
                <el-col :span="12" class="text-xs-right">{{order.payment_type}}</el-col>
              </el-row>
              <v-divider class="my-3"></v-divider>
              <el-row :gutter="15" class="headline font-weight-bold">
                <el-col :span="12">Total</el-col>
                <el-col
                  :span="12"
                  class="text-xs-right"
                >฿ {{order.amount.total | numFormat('0,0.00')}}</el-col>
              </el-row>
              <div class="mt-3">
                <el-button
                  type="primary"
                  style="width:100%;"
                  @click="onCreateOrder('asap')"
                >Place an Order</el-button>
              </div>
            </el-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <address-dialog :showDialog="addressDialog" @save="onSaveAddress" @close="addressDialog=false"></address-dialog>
    <basket-dialog
      :showDialog="basketDialog"
      :ent_id="ent_id"
      @save="onSaveBasket"
      @close="basketDialog=false"
    ></basket-dialog>
    <user-dialog :showDialog="userDialog" @save="onSaveUser" @close="userDialog=false"></user-dialog>
    <recipient-dialog
      :showDialog="recipientDialog"
      @save="onSaveRecipient"
      @close="recipientDialog=false"
    ></recipient-dialog>
  </div>
</template>
<script>
import Service from "../../services";

import AddressDialog from "../../components/AddressDialog";
import BasketDialog from "../../components/BasketDialog";
import UserDialog from "../../components/UserDialog";
import RecipientDialog from "../../components/RecipientDialog";
import { setTimeout } from "timers";

export default {
  components: {
    AddressDialog,
    BasketDialog,
    UserDialog,
    RecipientDialog
  },
  data() {
    return {
      ent_id: null,
      loading: null,
      enableDate: false,
      addressDialog: false,
      basketDialog: false,
      userDialog: false,
      recipientDialog: false,
      activeNames: ["0"],
      form: { mobile: "" },
      orderTypeList: [
        { name: "เดลิเวอรี่", value: "delivery", selected: true },
        { name: "รับกลับบ้าน", value: "pickup", selected: false }
        /*
        { name: "Cloud Kitchen", value: "cloudkitchen", selected: false },
        { name: "Catering", value: "catering", selected: false },
        { name: "Coupon", value: "coupon", selected: false }
        */
      ],
      paymentList: [
        { name: "เงินสด", value: "cash", selected: true },
        { name: "โอนเงิน", value: "transfer", selected: false },
        { name: "บัตรเครดิต", value: "creditcard", selected: false },
        { name: "LINE PAY", value: "linepay", selected: false }
      ],
      order: {
        order_type: "delivery",
        channel: "callcenter",
        user_id: null,
        user_recipient_id: null,
        user_address_id: null,
        user_tax_id: null,
        user_ref_json: null,
        basket: [],
        amount: {
          sub_total: 0,
          delivery_fee: 0,
          discount: 0,
          extra_fee: 0,
          total: 0
        },
        payment_type: "cash",
        card_token: null,
        user_address_info: null,
        delivery_info: {
          whereTo: { label: "", address: "" },
          when: { text: "asap" }
        },
        remark_internal: "",
        remark_public: ""
      },
      //price: { food: 0, delivery: 0, extra: 0 },
      user: { mobile: "" },
      date: "2019-05-15 12:00:00"
    };
  },
  computed: {},
  created() {
    if (this.$route.query.ent_id) {
      this.ent_id = this.$route.query.ent_id;
    }
    //Service.Order.gets().then(res => {});

    var d1 = new Date(),
      d2 = new Date(d1);
    d2.setMinutes(d1.getMinutes() + 30);
    this.date = d2;
  },
  methods: {
    findMobile() {
      this.showLoading();
      Service.Auth.checkIndentity("mobile", this.form.mobile).then(res => {
        if (res.data.found) {
          Service.Auth.getUser(res.data.user.id).then(user => {
            this.user = user.users[0];
            this.order.user_ref_json = this.user;
            this.hideLoading();
          });
        } else {
          this.recipientDialog = true;
          this.hideLoading();
        }
      });
    },
    /*
    selectDelivery() {
      console.log("selectDelivery");
    },
    */
    onOrderTypeChanged(selected) {
      this.orderTypeList = this.orderTypeList.map(item => {
        if (item.value == selected.value) {
          this.order.order_type = item.value;
          return { ...item, selected: true };
        } else {
          return { ...item, selected: false };
        }
      });
      this.activeNames = ["1"];
    },
    onPaymentChanged(selected) {
      this.paymentList = this.paymentList.map(item => {
        if (item.value == selected.value) {
          this.order.payment_type = item.value;
          return { ...item, selected: true };
        } else {
          return { ...item, selected: false };
        }
      });
    },
    onSaveBasket(data) {
      this.showLoading();
      /*
      this.order.basket = data.basket;
      

      this.price.food = 0;
      this.order.basket.map(item => {
        this.price.food += item.regular_price * item.quantity;
      });
      console.log(this.order.when);
      */
      this.order.delivery_info = {
        ...this.order.delivery_info,
        whereFrom: data.shop
      };

      let stops = [
        {
          location: {
            lat: this.order.delivery_info.whereFrom.latitude.toString(),
            lng: this.order.delivery_info.whereFrom.longitude.toString()
          },
          addresses: {
            en_TH: {
              displayString: this.order.delivery_info.whereFrom.name,
              country: "TH"
            }
          }
        }
      ];

      if (this.order.order_type == "delivery") {
        stops.push({
          location: {
            lat: this.order.delivery_info.whereTo.lat.toString(),
            lng: this.order.delivery_info.whereTo.lng.toString()
          },
          addresses: {
            en_TH: {
              displayString: this.order.delivery_info.whereTo.place_name,
              country: "TH"
            }
          }
        });
      }
      let params = {
        special_requests: ["LALABAG", "HELP_BUY"],
        order_type: this.order.order_type,
        basket: data.basket,
        shop_id: data.shop.shop_id,
        channel: this.order.channel,
        promocode: { value: "" },
        payment_type: this.order.payment_type,
        stops: stops,
        schedule_at: this.order.delivery_info.when.text
      };
      Service.Delivery.getDeliveryFee(params).then(res => {
        this.order.amount = res.data.order.amount;
        this.order.basket = res.data.order.product_list;
        this.hideLoading();
      });
      this.basketDialog = false;
    },
    onSaveAddress(data) {
      this.order.delivery_info = {
        ...this.order.delivery_info,
        whereTo: data
      };
      this.addressDialog = false;
    },
    onSaveUser(data) {
      this.order.user_ref_json = data;
      this.userDialog = false;
    },
    onSaveRecipient(data) {
      this.order.user_ref_json = data;
      this.recipientDialog = false;
    },
    onCreateOrder(when) {
      /*
      if (when == "asap") {
      } else if (when == "scheduled") {
        this.order.delivery_info.when.text = "scheduled";
        this.order.delivery_info.when.date = this.date;
      }
      */
      this.order.amount.subtotal = this.order.amount.sub_total;
      this.order.amount.deliveryFee = this.order.amount.delivery_fee;
      this.order.amount.extraFee = this.order.amount.extra_fee;

      this.showLoading();
      Service.Order.addOrder(this.order).then(res => {
        if (res.success) {
          this.$router.push("/view/order/" + res.data.order.order_id);
        } else {
        }
        this.hideLoading();
      });
    },
    onDateChanged(val) {
      let bufferTime = 1000 * 60 * 45;
      let now = new Date();
      let date = new Date(val);
      const diffTime = Math.abs(date.getTime() - now.getTime());

      console.log(val.toISOString());
      /*
      console.log(diffTime);
      if (diffTime < 0) {
        console.log("invalid Date");
      }
      */

      if (diffTime > bufferTime) {
        //console.log("schedule");
        this.order.delivery_info.when.text = val.toISOString();
      } else {
        this.order.delivery_info.when.text = "asap";
      }
      this.order.delivery_info.when.date = new Date(this.date).toISOString();
    },
    showLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });
    },
    hideLoading() {
      this.loading.close();
    }
  }
};
</script>

